<template>
<div style=" background:#F8F8F8">
    <div class=" padding-ten-lr ">
        <b-row style="max-width:100%">
            <b-col xs="12" sm="12" md="12" lg="4" style="padding-left:5%">
                <h5 class="color-gray " style="text-align:left;padding:0.75rem 1rem;font-size:1.15rem;font-weight:bold;">
                    Detalle de Venta
                </h5>
            </b-col>
            <b-col cols="8" style="text-align:right " class="xs-hidden">
                <b-breadcrumb>
                    <b-breadcrumb-item class="color-orange text-mediun">
                        <router-link to="/search-ticket">Consulta por ticket
                        </router-link>
                    </b-breadcrumb-item>
                    <b-breadcrumb-item active class="text-mediun">Detalle de venta</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
        </b-row>
    </div>
    <section class="padding-two-lr">
        <b-container>
            <b-row>
                <b-col cols="12">
                    <b-tabs content-class="mt-3">
                        <b-tab title="Datos de Transacción" active class="text-mediun">
                            <b-card class="box-shadow-light">
                                <b-row class="padding-two-tb" no-gutters style="border-bottom:1px solid rgb(222, 226, 230)">
                                    <b-col cols="6" lg="2" class="padding-none-left text-left">
                                        <label>
                                            F. Compra
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.oSales.heD_FCONTABLE }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="2" class="padding-none text-left">
                                        <label>
                                            F. Proceso
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.oSales.heD_FPROCESO }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="1" class="text-left">
                                        <label>
                                            Local
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.oSales.heD_LOCAL }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="1" class="text-left">
                                        <label>
                                            Caja
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.oSales.heD_POS }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="1" class="padding-none text-left">
                                        <label>
                                            Secuencia
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.oSales.heD_NUMTRX }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="2" class="text-left padding-left-two">
                                        <label>
                                            Folio
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.oSales.heD_NUMDOCDEL }}
                                        </span>
                                    </b-col>

                                    <b-col cols="6" lg="1" class="text-left">
                                        <label>
                                            N.V/T.A
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.oSales.heD_CNEGOP }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="2" class="text-left">
                                        <label>
                                            Tipo de transacción
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.oSales.heD_TIPODOC }}
                                        </span>
                                    </b-col>
                                </b-row>

                                <b-row class="padding-two-tb" no-gutters style="border-bottom:1px solid rgb(222, 226, 230) ">
                                    <b-col cols="6" lg="2" class="text-left padding-none-left">
                                        <label>
                                            Ruc/Dni
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.oSales.heD_RUTDOC }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="2" class="text-left">
                                        <label>
                                            Monto
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.oSales.heD_TOTAL }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="2" class="text-left">
                                        <label>
                                            Cajero
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.oSales.heD_CAJERO }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="1" class="text-left">
                                        <label>
                                            Trx Glovo
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.oSales.prM_CODPROM }}
                                        </span>
                                    </b-col>
                                </b-row>
                                <b-row class="padding-two-tb" no-gutters>
                                    <b-col cols="6" lg="10" class="padding-none-left">
                                        <label>
                                            Link de comprobante
                                        </label>
                                        <span class="color-gray text-large">                                            
                                            <a
                                                v-if="detailTRX.oSales.urL_SOVOS !== '-'"
                                                :href="detailTRX.oSales.urL_SOVOS"
                                                :download="detailTRX.oSales.heD_NUMDOCDEL"
                                                target="_blank"
                                                rel="noopener"
                                            >
                                                Descargar Documento
                                            </a>
                                            <span v-else>Sin Documento</span>
                                        </span>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-row>
                                <b-col cols="12" class="padding-two-tb">
                                    <h6 class="color-orange">Datos de pagos</h6>
                                </b-col>
                            </b-row>
                            <b-card class="box-shadow-light hidden-xs">
                                <b-row no-gutters>
                                    <b-col cols="12" class=" ">
                                        <div class="bg-white  ">
                                            <b-table :items="detailTRX.oSales.list_payment" :fields="fields"></b-table>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-card class="box-shadow-light xs-show">
                                <b-row no-gutters>
                                    <b-col cols="12" class=" ">
                                        <div class="bg-white  ">
                                            <b-table :items="detailTRX.oSales.list_payment" :fields="fieldsPayment">
                                                <template v-slot:cell(actions)="row">
                                                    <b-button style="background:transparent;color:#545b62;border-color:transparent" size="sm" @click="row.toggleDetails">
                                                        <font-awesome-icon :icon="
                                  row.detailsShowing
                                    ? 'chevron-up'
                                    : 'chevron-down'
                                " />
                                                    </b-button>
                                                </template>
                                                <template #row-details="row">
                                                    <b-card>
                                                        <b-row>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Monto:
                                                                </label>
                                                                <span>{{ row.item.heD_FPROCESO }} </span>
                                                            </b-col>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Cuenta:
                                                                </label>
                                                                <span>{{ row.item.paG_MONTO }} </span>
                                                            </b-col>
                                                        </b-row>
                                                    </b-card>
                                                </template>
                                            </b-table>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-row>
                                <b-col cols="12" class="padding-two-tb">
                                    <h6 class="color-orange">Detalle de productos</h6>
                                </b-col>
                            </b-row>
                            <b-card class="box-shadow-light margin-seven-bottom hidden-xs">
                                <b-row no-gutters>
                                    <b-col cols="12" class=" ">
                                        <div class="bg-white  ">
                                            <b-table :items="detailTRX.oSales.list_detail" :fields="fieldsDetails"></b-table>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-card class="box-shadow-light xs-show">
                                <b-row no-gutters>
                                    <b-col cols="12" class=" ">
                                        <div class="bg-white  ">
                                            <b-table :items="detailTRX.oSales.list_detail" :fields="fieldsDetXS">
                                                <template v-slot:cell(actions)="row">
                                                    <b-button style="background:transparent;color:#545b62;border-color:transparent" size="sm" @click="row.toggleDetails">
                                                        <font-awesome-icon :icon="
                                  row.detailsShowing
                                    ? 'chevron-up'
                                    : 'chevron-down'
                                " />
                                                    </b-button>
                                                </template>
                                                <template #row-details="row">
                                                    <b-card>
                                                        <b-row>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Sku:
                                                                </label>
                                                                <span>{{ row.item.prD_LVL_NUMBER }} </span>
                                                            </b-col>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Cantidad:
                                                                </label>
                                                                <span>{{ row.item.ptR_UNIDADES }} </span>
                                                            </b-col>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Precio venta:
                                                                </label>
                                                                <span>{{ row.item.ptR_PRECIOVTA }} </span>
                                                            </b-col>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Monto dsct:
                                                                </label>
                                                                <span>{{ row.item.ptR_MDESCTO }} </span>
                                                            </b-col>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Total:
                                                                </label>
                                                                <span>{{ row.item.ptR_TOTAL }} </span>
                                                            </b-col>
                                                        </b-row>
                                                    </b-card>
                                                </template>
                                            </b-table>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-tab>
                        <b-tab v-if="detailTRX.referencias.length > 0" title="Referencias de Transacción" class="text-mediun">
                            <b-row no-gutters>
                                <b-col cols="12" class="padding-two-bottom">
                                    <b-pagination hide-goto-end-buttons v-model="currentPage" :total-rows="rows" :per-page="perPage" pills align="center" size="md" class="my-0"></b-pagination>
                                </b-col>
                            </b-row>
                            <b-card class="box-shadow-light">
                                <b-row class="padding-two-tb" no-gutters style="border-bottom:1px solid rgb(222, 226, 230)">
                                    <b-col cols="6" lg="2" class="padding-none-left text-left">
                                        <label>
                                            F. Compra
                                        </label>
                                        <span class="color-gray text-large">
                                            {{
                          detailTRX.referencias[currentPosition].heD_FCONTABLE
                        }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="2" class="padding-none text-left">
                                        <label>
                                            F. Proceso
                                        </label>
                                        <span class="color-gray text-large">
                                            {{
                          detailTRX.referencias[currentPosition].heD_FCONTABLE
                        }}
                                        </span>
                                    </b-col>
                                    <b-col lg="1" class="text-left">
                                        <label>
                                            Local
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.referencias[currentPosition].heD_LOCAL }}
                                        </span>
                                    </b-col>
                                    <b-col lg="1" class="text-left">
                                        <label>
                                            Caja
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.referencias[currentPosition].heD_POS }}
                                        </span>
                                    </b-col>
                                    <b-col lg="1" class="padding-none text-left">
                                        <label>
                                            Secuencia
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.referencias[currentPosition].heD_NUMTRX }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="2" class="text-left padding-left-two">
                                        <label>
                                            Folio
                                        </label>
                                        <span class="color-gray text-large">
                                            {{
                          detailTRX.referencias[currentPosition].heD_NUMDOCDEL
                        }}
                                        </span>
                                    </b-col>

                                    <b-col lg="1" class="text-left">
                                        <label>
                                            N.V/T.A
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.referencias[currentPosition].heD_CNEGOP }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="2" class="text-left">
                                        <label>
                                            Tipo de transacción
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.referencias[currentPosition].heD_TIPODOC }}
                                        </span>
                                    </b-col>
                                </b-row>
                                <b-row class="padding-two-tb" no-gutters style="border-bottom:1px solid rgb(222, 226, 230) ">
                                    <b-col cols="6" lg="2" class="text-left padding-none-left">
                                        <label>
                                            Ruc/Dni
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.referencias[currentPosition].heD_RUTDOC }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="2" class="text-left">
                                        <label>
                                            Monto
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.referencias[currentPosition].heD_TOTAL }}
                                        </span>
                                    </b-col>
                                    <b-col cols="6" lg="2" class="text-left">
                                        <label>
                                            Cajero
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.referencias[currentPosition].heD_CAJERO }}
                                        </span>
                                    </b-col>
                                    <b-col lg="1" class="text-left">
                                        <label>
                                            Estado
                                        </label>
                                        <span class="color-gray text-large">
                                            {{ detailTRX.referencias[currentPosition].heD_ANULADO }}
                                        </span>
                                    </b-col>
                                </b-row>
                                <b-row class="padding-two-tb" no-gutters>
                                    <b-col lg="10" class="padding-none-left">
                                        <label>
                                            Link de comprobante
                                        </label>
                                        <span class="color-gray text-large">                                            
                                            <a
                                                v-if="detailTRX.referencias[currentPosition].urL_SOVOS !== '-'"
                                                :href="detailTRX.referencias[currentPosition].urL_SOVOS"
                                                :download="detailTRX.referencias[currentPosition].heD_NUMDOCDEL"
                                                target="_blank"
                                                rel="noopener"
                                            >
                                                Descargar Documento
                                            </a>
                                            <span v-else>Sin Documento</span>
                                        </span>
                                    </b-col>
                                </b-row>
                            </b-card>

                            <b-row>
                                <b-col cols="12" class="padding-two-tb 
">
                                    <h6 class="color-orange">Datos de pagos</h6>
                                </b-col>
                            </b-row>
                            <b-card class="box-shadow-light xs-hidden">
                                <b-row no-gutters>
                                    <b-col cols="12" class=" ">
                                        <div class="bg-white  ">
                                            <b-table :items="
                            detailTRX.referencias[currentPosition].list_payment
                          " :fields="fields"></b-table>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-card class="box-shadow-light xs-show">
                                <b-row no-gutters>
                                    <b-col cols="12" class=" ">
                                        <div class="bg-white  ">
                                            <b-table :items="
                            detailTRX.referencias[currentPosition].list_payment
                          " :fields="fieldsPayment">
                                                <template v-slot:cell(actions)="row">
                                                    <b-button style="background:transparent;color:#545b62;border-color:transparent" size="sm" @click="row.toggleDetails">
                                                        <font-awesome-icon :icon="
                                  row.detailsShowing
                                    ? 'chevron-up'
                                    : 'chevron-down'
                                " />
                                                    </b-button>
                                                </template>
                                                <template #row-details="row">
                                                    <b-card>
                                                        <b-row>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Monto:
                                                                </label>
                                                                <span>{{ row.item.heD_FPROCESO }} </span>
                                                            </b-col>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Cuenta:
                                                                </label>
                                                                <span>{{ row.item.paG_MONTO }} </span>
                                                            </b-col>
                                                        </b-row>
                                                    </b-card>
                                                </template>
                                            </b-table>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-row>
                                <b-col cols="12" class="padding-two-tb">
                                    <h6 class="color-orange">Detalle de productos</h6>
                                </b-col>
                            </b-row>
                            <b-card class="box-shadow-light margin-seven-bottom hidden-xs">
                                <b-row no-gutters>
                                    <b-col cols="12" class=" ">
                                        <div class="bg-white  ">
                                            <b-table :items="
                            detailTRX.referencias[currentPosition].list_detail
                          " :fields="fieldsDetails"></b-table>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-card class="box-shadow-light xs-show">
                                <b-row no-gutters>
                                    <b-col cols="12" class=" ">
                                        <div class="bg-white  ">
                                            <b-table :items="
                            detailTRX.referencias[currentPosition].list_detail
                          " :fields="fieldsDetXS">
                                                <template v-slot:cell(actions)="row">
                                                    <b-button style="background:transparent;color:#545b62;border-color:transparent" size="sm" @click="row.toggleDetails">
                                                        <font-awesome-icon :icon="
                                  row.detailsShowing
                                    ? 'chevron-up'
                                    : 'chevron-down'
                                " />
                                                    </b-button>
                                                </template>
                                                <template #row-details="row">
                                                    <b-card>
                                                        <b-row>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Sku:
                                                                </label>
                                                                <span>{{ row.item.prD_LVL_NUMBER }} </span>
                                                            </b-col>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Cantidad:
                                                                </label>
                                                                <span>{{ row.item.ptR_UNIDADES }} </span>
                                                            </b-col>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Precio venta:
                                                                </label>
                                                                <span>{{ row.item.ptR_PRECIOVTA }} </span>
                                                            </b-col>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Monto dsct:
                                                                </label>
                                                                <span>{{ row.item.ptR_MDESCTO }} </span>
                                                            </b-col>
                                                            <b-col cols="12" class="text-sm-right">
                                                                <label class="text-grey" style="display:inline" for="">Total:
                                                                </label>
                                                                <span>{{ row.item.ptR_TOTAL }} </span>
                                                            </b-col>
                                                        </b-row>
                                                    </b-card>
                                                </template>
                                            </b-table>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-container>
    </section>
</div>
</template>

<script>
import axios from "axios";
export default {
    name: "DetailsTRX",
    data() {
        return {
            perPage: 1,
            pageOptions: [5, 10, 15],
            currentPage: 1,
            fields: [{
                    key: "paG_CORRPAGO",
                    label: "N°"
                },

                {
                    key: "tpA_DESPAGO",
                    label: "Medio de pago"
                },
                {
                    key: "paG_MONTO",
                    label: "Monto"
                },
                {
                    key: "paG_NUMCTA",
                    label: "Cuenta"
                },
                {
                    key: "paG_NROUNICO",
                    label: "Nro Unico"
                },
                {
                    key: "paG_NUMVOUCH",
                    label: "Referencia de pago "
                },
                {
                    key: "paG_CODAUTOR",
                    label: "Codigo de autor"
                }
            ],
            fieldsPayment: [{
                    key: "actions",
                    label: ""
                },
                {
                    key: "tpA_DESPAGO",
                    label: "Medio de pago"
                },
            ],
            fieldsDetails: [{
                    key: "ptR_CORRPROD",
                    label: "N°"
                },
                {
                    key: "prD_LVL_NUMBER",
                    label: "Sku"
                },
                {
                    key: "prD_FULL_NAME",
                    label: "Producto"
                },
                {
                    key: "ptR_UNIDADES",
                    label: "Cantidad"
                },
                {
                    key: "ptR_PRECIOVTA",
                    label: "Precio venta"
                },
                {
                    key: "ptR_MDESCTO",
                    label: "Monto desct."
                },

                {
                    key: "ptR_TOTAL",
                    label: "Total"
                },
            ],
            fieldsDetXS: [{
                    key: "actions",
                    label: ""
                },
                {
                    key: "prD_FULL_NAME",
                    label: "Producto"
                },
            ],

            referencesFields: [{
                    key: "heD_FCONTABLE",
                    label: "F. Compra"
                },
                {
                    key: "heD_FPROCESO",
                    label: "F. Proceso"
                },
                {
                    key: "heD_LOCAL",
                    label: "Local"
                },
                {
                    key: "heD_POS",
                    label: "Caja"
                },
                {
                    key: "heD_NUMTRX",
                    label: "Secuencia"
                },
                {
                    key: "heD_NUMDOCDEL",
                    label: "Folio"
                },
                {
                    key: "heD_TOTAL",
                    label: "Monto"
                },
                {
                    key: "heD_TIPODOC",
                    label: "Tipo de transacción"
                },
                {
                    key: "heD_RUTDOC",
                    label: "Ruc"
                },
            ],
            detailTRX: {
                oSales: {},
                referencias: []
            },
        };
    },
    computed: {
        rows() {
            return this.detailTRX.referencias.length;
        },
        currentPosition() {
            return this.currentPage - 1;
        },
    },
    created() {
        this.getDetails();
    },
    methods: {
        async getDetails() {
            try {
                this.$store.commit("SET_LOADING", true);
                let response = await axios.get(
                    process.env.VUE_APP_URL_API +
                    "/v1/sales/transaction?Fecha=" +
                    this.$route.params.date +
                    "&Local=" +
                    this.$route.params.local +
                    "&Pos=" +
                    this.$route.params.pos +
                    "&Secuencia=" +
                    this.$route.params.id
                );
                this.detailTRX = response.data;
                //this.detailsOS = response.data;
            } catch (error) {
                if (!error.response) {
                    let values = {
                        variant: "danger",
                        msg: 'Please check your internet connection.'
                    };
                    this.$store.commit("SET_SHOW_ALERT", true);
                    this.$store.commit("SET_MSG_RESPONSE", values);
                } else {
                    let values = {
                        variant: "danger",
                        msg: 'Error del servidor'
                    };
                    this.$store.commit("SET_SHOW_ALERT", true);
                    this.$store.commit("SET_MSG_RESPONSE", values);
                }

                setTimeout(() => this.$store.commit("SET_SHOW_ALERT", false), 2000);
            } finally {
                this.$store.commit("SET_LOADING", false);

            }
        },
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style scoped>
.text-left {
    text-align: left;
}

::v-deep .nav-tabs .nav-link.active {
    background: transparent !important;
    border-top: none;
    border-left: none;
    border-right: none;
    color: #ff7200;
    border-color: transparent;
}

::v-deep.nav-tabs .nav-link {
    border-color: #dee2e6 !important;
}

::v-deep .page-item.active .page-link {
    background: #ff6e00 !important;
    border-color: #ff6e00 !important;
    color: white !important;
}

::v-deep .page-item.disabled .page-link {
    background: transparent !important;
    border-color: transparent !important;
    font-size: 28px;
}

::v-deep .page-link {
    color: #676767 !important;
    border-color: transparent;
    font-weight: bold;
    background: transparent !important;
}

::v-deep .page-item button[role="menuitem"] {
    font-size: 28px;
}

ul {
    display: flex;
    align-items: center;
}

::v-deep .nav-link {
    color: #676767;
}

.padding-two-bottom {
    padding-bottom: 2%;
}

.card {
    border-color: transparent !important;
}

::v-deep .nav-tabs .nav-item .active::after {
    content: "";
    position: absolute;
    left: 50%;
    margin-left: -50px;
    bottom: 0;
    width: 100px;
    border-bottom: 4px solid #ff7200 !important;
    border-radius: 5px;
    border: none;
    background: transparent !important;
}

::v-deep .nav-item {
    position: relative !important;
}

.hidden-icon {
    visibility: hidden;
}

.padding-two-tb {
    padding-top: 2%;
    padding-bottom: 2%;
}

.margin-seven-bottom {
    margin-bottom: 3%;
}

.xs-show {
    display: none;
    visibility: hidden;
}

@media (max-width: 600px) {
    .hidden-xs {
        display: none;
    }

    .padding-none-left {
        padding-left: 0 !important;
    }

    .padding-left-two {
        padding-left: 0 !important;
    }

    .xs-hidden {
        display: none;
    }

    .xs-show {
        display: -webkit-box !important;
        visibility: visible !important;
    }

    .show-icon {
        visibility: visible;
        padding-right: 4px;
    }
}

.box-shadow-light {
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
    border-radius: 13px;
}

.color-gray {
    color: #676767;
}

.color-orange {
    color: #ff7200 !important;
    font-weight: bold;
}

a {
    color: #ff7200 !important;
}

.padding-ten-lr {
    padding: 10px;
    padding-left: 30px !important;
}

.bg-white {
    background: white;
}

.padding-five-lr {
    padding: 20px;
}

::v-deep .form-control {
    border-color: transparent;
    background: transparent !important;
    text-align: left;
    padding-left: 0;
}

.bg-grey-btn {
    background: #676767;
    color: white;
}

.bg-orange-btn {
    background: #ff7a00;
    color: white;
    border-color: transparent !important;
}

.padding-seven-all {
    padding-top: 0.85rem;
    padding-bottom: 0.85rem;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
}

.padding-none {
    padding: 0;
}

.margin-five-rigth {
    margin-right: 50%;
}

.table-wrapp {
    display: block;

    overflow-x: scroll;
}

.padding-left-two {
    padding-left: 15px;
}

.bg-oran {
    background: transparent;
    color: #ff7a00;
    border-color: transparent;
    margin-left: 15px;
    font-weight: bold;
}

.padding-two-lr {
    padding-left: 2%;
    padding-right: 2%;
}

.text-orange {
    color: #ff7a00;
}

label {
    display: block;
    color: black;
    font-weight: bolder;
    font-size: 11pt;
}

.padding-five-all {
    margin-top: 15px;
    margin-bottom: 15px;
    margin-left: 30px;
    margin-right: 30px;
    padding: 19px;
    border-radius: 10px;
}

.text-mediun {
    font-size: 11.5pt;
}

.text-large {
    font-size: 11pt;
}

.table th,
.table td {
    padding: 0.5rem;
}

::v-deep .b-table thead {
    background-color: transparent !important;
    color: black !important;
    font-weight: 500 !important;
    border: none !important;
}

::v-deep .table tr:first-child td {
    border-top: 1px solid transparent !important;
}

::v-deep .table td {
    color: #676767;
    font-size: 11pt;
}

::v-deep .b-table thead th {
    font-weight: 700 !important;
    border: none !important;
    font-size: 11pt;
}

table {
    margin-bottom: 0 !important;
}

.text-grey {
    color: #676767;
    font-size: 15px;
    letter-spacing: 0px;
    display: block;
    margin-bottom: 0;
}

.breadcrumb {
    background: transparent;
    float: right;
}

@media (max-width: 575.98px) {
    .margin-five-rigth {
        margin: 0;
    }

    .padding-five-bottom {
        padding-bottom: 5px;
    }

    .text-grey {
        color: #676767;
        font-size: 15px;
        letter-spacing: 0px;
        display: block;
        margin-bottom: 0.5rem;
    }
}

.custom-select:focus {
    border-color: transparent !important;
    box-shadow: none;
}

.form-control:focus {
    border-color: transparent !important;
    box-shadow: none;
}
</style>
